import { Backdrop, Box, CircularProgress } from "@mui/material";
import colors from "../config/colors";

const Loading = ({
  isLoading = true,
  content = <></>,
}: {
  isLoading?: boolean;
  content?: React.ReactNode;
}) => {
  return (
    <Backdrop
      sx={{
        color: colors.loadingComponentColor,
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
      open={isLoading}
    >
      <Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress color="inherit" />
          {content}
        </Box>
      </Box>
    </Backdrop>
  );
};

export default Loading;
